import { Row, Col, Container } from 'react-bootstrap';
import { Link, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { exchangeCodeForToken } from './client';
import { decodeJwt } from 'jose';
import logoUrl from '../../assets/portal_logo.svg';
import { hasToken, setAuthStore, setSessionStore } from './sessionStore';
import { logLoginManually } from './siemReporterMutations';
import { logger } from '../../lib/logger';

export const Callback = () => {
  const [error, setError] = useState(null);
  const [authenticated, setAuthenticated] = useState(hasToken());

  useEffect(() => {
    let cancel = false;

    // Don't attempt token exchange during/after logout
    if (sessionStorage.getItem('unauthenticated') === 'true') return;
    if (authenticated) return;

    (async () => {
      try {
        // exchangeCodeForToken returns { access_token, refresh_token, id_token }
        // — only the fields the portal actually uses, no extra Keycloak fields
        const tokens = await exchangeCodeForToken(window.location.href);

        setAuthStore(tokens);
        setSessionStore({
          ignore:                false,
          subscriptionsQueried:  false,
          subscriptionsAck:      false,
        });

        // SIEM logging is isolated from the auth flow —
        // failures here cannot block navigation
        (async () => {
          try {
            const decoded = decodeJwt(tokens.access_token);
            const iso = new Date(decoded.exp * 1000).toISOString().split('.')[0] + 'Z';
            await logLoginManually(tokens.access_token, iso);
          } catch {
            logger.error('Failed to log portal login event');
          }
        })();

        if (!cancel) {
          setAuthenticated(true);
        }
      } catch (err) {
        if (cancel) return;
        setError(err);
      }
    })();

    return () => { cancel = true; };
  }, []);

  if (authenticated) {
    return <Navigate to={'/'} replace />;
  }

  return (
    <Container fluid className="signin">
      <Row>
        <Col>
          <Row className="py-5">
            <Col className="text-center">
              <div className="login-logo mx-auto">
                <img src={logoUrl} alt="Fulcrum Portal" />
              </div>

              {error ? (
                <div data-testid="error" className="login-linkss">
                  <p>Sorry, there was an error with your login.</p>
                  <p><b>Description: </b>{error.message}<br /></p>
                  <p>You may need to <Link to={'/signin'}>try again</Link>.</p>
                </div>
              ) : (
                <div data-testid="welcome" className="form-group">
                  <p>Welcome back!</p>
                  <p>Please wait while we process your authentication.</p>
                </div>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};
